import { useState } from 'react'
import { Search, RotateCcw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import type { EmployeeOrderListParams } from '@/types/employee'

interface OrderFilterBarProps {
  params: EmployeeOrderListParams
  onParamsChange: (params: Partial<EmployeeOrderListParams>) => void
}

export function OrderFilterBar({ params, onParamsChange }: OrderFilterBarProps) {
  const [localOrderNo, setLocalOrderNo] = useState(params.order_no || '')
  const [localPhone, setLocalPhone] = useState(params.phone || '')
  const [localDate, setLocalDate] = useState(params.date || '')

  const handleSearch = () => {
    onParamsChange({
      order_no: localOrderNo || undefined,
      phone: localPhone || undefined,
      date: localDate || undefined,
    })
  }

  const handleReset = () => {
    setLocalOrderNo('')
    setLocalPhone('')
    setLocalDate('')
    onParamsChange({
      order_no: undefined,
      phone: undefined,
      date: undefined,
    })
  }

  return (
    <div className="flex flex-wrap items-end gap-4 rounded-lg border bg-card p-4">
      <div className="flex flex-col gap-1.5">
        <label htmlFor="employee-order-filter-no" className="text-sm font-medium text-muted-foreground">订单编号</label>
        <Input
          id="employee-order-filter-no"
          placeholder="请输入订单编号"
          value={localOrderNo}
          onChange={(e) => setLocalOrderNo(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
          className="w-48"
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <label htmlFor="employee-order-filter-phone" className="text-sm font-medium text-muted-foreground">客户手机号</label>
        <Input
          id="employee-order-filter-phone"
          placeholder="请输入手机号"
          value={localPhone}
          onChange={(e) => setLocalPhone(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
          className="w-48"
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <label htmlFor="employee-order-filter-date" className="text-sm font-medium text-muted-foreground">日期范围</label>
        <Input
          id="employee-order-filter-date"
          placeholder="2026-03-03 - 2026-03-05"
          value={localDate}
          onChange={(e) => setLocalDate(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
          className="w-64"
        />
      </div>
      <div className="flex gap-2">
        <Button size="sm" onClick={handleSearch}>
          <Search className="mr-1.5 h-4 w-4" />
          搜索
        </Button>
        <Button variant="outline" size="sm" onClick={handleReset}>
          <RotateCcw className="mr-1.5 h-4 w-4" />
          重置
        </Button>
      </div>
    </div>
  )
}
